// @flow

import * as React from 'react';

import { Ban } from 'lucide-react';

import { ListRow } from '../../../../ListRow';

type Props = {
  children?: React.Node,
  cta?: React.Node,
  options?: Array<React.Node>,
  title?: string,
};

export default function ErrorItem({
  children,
  cta,
  options,
  title,
}: Props): React.MixedElement {
  return children || options?.length === 1 ? (
    <ListRow icon={<Ban />} intent="danger" cta={cta}>
      {children || options}
    </ListRow>
  ) : (
    <ListRow
      icon={<Ban />}
      intent="danger"
      cta={cta}
      options={options}
      title={title}
      optionsArrow={false}
    />
  );
}
